import React from "react"
import "./index.scss"
import { ISankeyHeader } from "./interface"

const SankeyHeader: React.FC<ISankeyHeader> = ({
	title,
	type,
	sankeyFooter,
	totalEarnings,
}) => {
	return (
		<div className="sankey_header" data-id="sankey_header">
			<div className={`sankey_title sankey_title-${type}`}>
				<p className="sankey_title-bold" data-id="sankey_title-bold">
					{title}
				</p>
				<p className="sankey_footer" data-id="sankey_footer">
					{sankeyFooter}
					<p className={`sankey_footer-${type}`}> {totalEarnings}</p>
				</p>
			</div>
		</div>
	)
}

export default SankeyHeader
